function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg_12",
  x1: 0,
  y1: 0,
  x2: 1,
  y2: 0
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2b2b2b",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#d4d4d4",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg_143",
  x1: 0.80469,
  y1: 1,
  x2: 1,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9db5b5",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#624a4a",
  offset: 1
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "null"
}, /*#__PURE__*/React.createElement("rect", {
  x: -1,
  y: -1,
  width: 602,
  height: 602,
  id: "canvas_background",
  fill: "#c9c9c9",
  stroke: "null"
}), /*#__PURE__*/React.createElement("g", {
  id: "canvasGrid",
  display: "none",
  stroke: "null"
}, /*#__PURE__*/React.createElement("rect", {
  id: "svg_1",
  width: 1600,
  height: 1200,
  strokeWidth: 0,
  fill: "url(#gridpattern)",
  stroke: "null"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  stroke: "null"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  fill: "url(#svg_143)",
  strokeWidth: 1.5,
  x: 0.7481,
  y: 0.41013,
  width: 157.98991,
  height: 599.37381,
  id: "svg_5"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  fill: "url(#svg_12)",
  strokeWidth: 1.5,
  x: 139.12409,
  y: -0.14809,
  width: 40,
  height: 599.9006,
  id: "svg_9"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009e9e",
  strokeWidth: 1.5,
  d: "m53.17431,506.3862l-15.06253,15.06793l15.06393,15.06512l5.47909,-5.479l-9.5875,-9.58612l9.58551,-9.58614l-5.4785,-5.48179l0,0zm22.04519,0l-5.47513,5.48041l9.58554,9.58612l-9.58554,9.58495l5.47513,5.47897l15.06594,-15.0665l-15.06594,-15.06395z",
  id: "svg_153",
  stroke: "#d36200"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009e9e",
  strokeWidth: 1.5,
  d: "m53.17431,351.34646l-15.06253,15.06793l15.06393,15.06512l5.47909,-5.479l-9.5875,-9.58612l9.58551,-9.58614l-5.4785,-5.48179l0,0zm22.04519,0l-5.47513,5.48041l9.58554,9.58612l-9.58554,9.58495l5.47513,5.47897l15.06594,-15.0665l-15.06594,-15.06395z",
  id: "svg_172",
  stroke: "#d36200"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009e9e",
  strokeWidth: 1.5,
  d: "m53.17431,188.55474l-15.06253,15.06793l15.06393,15.06512l5.47909,-5.479l-9.5875,-9.58612l9.58551,-9.58614l-5.4785,-5.48179l0,0zm22.04519,0l-5.47513,5.48041l9.58554,9.58612l-9.58554,9.58495l5.47513,5.47897l15.06594,-15.0665l-15.06594,-15.06395z",
  id: "svg_174",
  stroke: "#d36200"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009e9e",
  strokeWidth: 1.5,
  d: "m53.17431,52.55446l-15.06253,15.06793l15.06393,15.06512l5.47909,-5.479l-9.5875,-9.58612l9.58551,-9.58614l-5.4785,-5.48179l0,0zm22.04519,0l-5.47513,5.48041l9.58554,9.58612l-9.58554,9.58495l5.47513,5.47897l15.06594,-15.0665l-15.06594,-15.06395z",
  id: "svg_6",
  stroke: "#d36200"
}), /*#__PURE__*/React.createElement("g", {
  id: "svg_8"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 116.14378,
  y: 281.7051,
  width: 40,
  height: 22.7025,
  id: "svg_119",
  rx: 8,
  transform: "rotate(-90 136.14378356933602,293.05627441406256) ",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#e00000",
  strokeWidth: 0.5,
  x: 127.63359,
  y: 289.6641,
  width: 26.00732,
  height: 6.2271,
  id: "svg_120",
  rx: 100,
  transform: "rotate(-90 140.63725280761727,292.77758789062506) ",
  stroke: "#333333"
})), /*#__PURE__*/React.createElement("g", {
  id: "svg_13"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 116.14378,
  y: 122.50477,
  width: 40,
  height: 22.7025,
  id: "svg_10",
  rx: 8,
  transform: "rotate(-90 136.14378356933597,133.85592651367188) ",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#e00000",
  strokeWidth: 0.5,
  x: 127.63359,
  y: 130.46377,
  width: 26.00732,
  height: 6.2271,
  id: "svg_11",
  rx: 100,
  transform: "rotate(-90 140.63725280761722,133.57723999023438) ",
  stroke: "#333333"
})), /*#__PURE__*/React.createElement("g", {
  id: "svg_14"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 116.14402,
  y: 448.72004,
  width: 40,
  height: 22.7025,
  id: "svg_122",
  rx: 8,
  transform: "rotate(-90 136.1440124511719,460.0711975097656) ",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#e00000",
  strokeWidth: 0.5,
  x: 127.63383,
  y: 456.67904,
  width: 26.00732,
  height: 6.2271,
  id: "svg_123",
  rx: 100,
  transform: "rotate(-90 140.63748168945315,459.7925109863281) ",
  stroke: "#333333"
})), /*#__PURE__*/React.createElement("rect", {
  transform: "rotate(180 521.72998046875,299.9382934570313) ",
  stroke: "null",
  fill: "url(#svg_143)",
  strokeWidth: 1.5,
  x: 442.73499,
  y: -0.14821,
  width: 157.98991,
  height: 600.17306,
  id: "svg_27"
}), /*#__PURE__*/React.createElement("rect", {
  transform: "rotate(180 442.34893798828125,300.2334899902344) ",
  stroke: "null",
  fill: "url(#svg_12)",
  strokeWidth: 1.5,
  x: 422.34896,
  y: -0.11679,
  width: 40,
  height: 600.70055,
  id: "svg_28"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(180 537.2744140625,78.28741455078125) ",
  stroke: "#d36200",
  fill: "#009e9e",
  strokeWidth: 1.5,
  d: "m526.25013,63.2008l-15.06253,15.08802l15.06393,15.08521l5.47909,-5.48631l-9.5875,-9.5989l9.58551,-9.59892l-5.4785,-5.4891l0,0zm22.04519,0l-5.47513,5.48772l9.58554,9.5989l-9.58554,9.59773l5.47513,5.48628l15.06594,-15.08659l-15.06594,-15.08404z",
  id: "svg_29"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(180 537.2744140625,233.53387451171875) ",
  stroke: "#d36200",
  fill: "#009e9e",
  strokeWidth: 1.5,
  d: "m526.25013,218.44724l-15.06253,15.08802l15.06393,15.08521l5.47909,-5.48631l-9.5875,-9.5989l9.58551,-9.59892l-5.4785,-5.4891l0,0zm22.04519,0l-5.47513,5.48772l9.58554,9.5989l-9.58554,9.59773l5.47513,5.48628l15.06594,-15.08659l-15.06594,-15.08404z",
  id: "svg_30"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(180 537.2744140625,396.54269409179693) ",
  stroke: "#d36200",
  fill: "#009e9e",
  strokeWidth: 1.5,
  d: "m526.25013,381.45608l-15.06253,15.08802l15.06393,15.08521l5.47909,-5.48631l-9.5875,-9.5989l9.58551,-9.59892l-5.4785,-5.4891l0,0zm22.04519,0l-5.47513,5.48772l9.58554,9.5989l-9.58554,9.59773l5.47513,5.48628l15.06594,-15.08659l-15.06594,-15.08404z",
  id: "svg_31"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(180 537.2744140625,532.7243041992188) ",
  stroke: "#d36200",
  fill: "#009e9e",
  strokeWidth: 1.5,
  d: "m526.25013,517.6377l-15.06253,15.08802l15.06393,15.08521l5.47909,-5.48631l-9.5875,-9.5989l9.58551,-9.59892l-5.4785,-5.4891l0,0zm22.04519,0l-5.47513,5.48772l9.58554,9.5989l-9.58554,9.59773l5.47513,5.48628l15.06594,-15.08659l-15.06594,-15.08404z",
  id: "svg_32"
}), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(180 465.32910156249994,466.4010620117188) ",
  stroke: "null",
  id: "svg_40"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 205.02186,
  y: 30.08912,
  width: 40,
  height: 22.7025,
  id: "svg_38",
  rx: 8,
  transform: "matrix(0,-1.001333475112915,1,0,423.8887023925781,691.7229905974746) "
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "#333333",
  fill: "#e00000",
  strokeWidth: 0.5,
  x: 216.51167,
  y: 38.04812,
  width: 26.00732,
  height: 6.2271,
  id: "svg_39",
  rx: 100,
  transform: "matrix(0,-1.001333475112915,1,0,428.6608581542969,695.9433936201749) "
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(180 465.32891845703125,139.7508544921875) ",
  stroke: "null",
  id: "svg_43"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 857.45251,
  y: 356.30402,
  width: 40,
  height: 22.7025,
  id: "svg_41",
  rx: 8,
  transform: "matrix(0,-1.001333475112915,1,0,97.67367553710932,1018.3733837719847) "
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "#333333",
  fill: "#e00000",
  strokeWidth: 0.5,
  x: 868.94232,
  y: 364.26302,
  width: 26.00732,
  height: 6.2271,
  id: "svg_42",
  rx: 100,
  transform: "matrix(0,-1.001333475112915,1,0,102.44589233398432,1022.5938479112301) "
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(180 464.1448974609375,293.056640625) ",
  id: "svg_50"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#9db5b5",
  strokeWidth: 1.5,
  x: 444.14444,
  y: 281.7051,
  width: 40,
  height: 22.7025,
  id: "svg_48",
  rx: 8,
  transform: "rotate(-90 464.1448059082032,293.0562744140625) ",
  stroke: "null"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#e00000",
  strokeWidth: 0.5,
  x: 455.63425,
  y: 289.6641,
  width: 26.00732,
  height: 6.2271,
  id: "svg_49",
  rx: 100,
  transform: "rotate(-90 468.63827514648443,292.77758789062506) ",
  stroke: "#333333"
})));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 600 600"
}, props), _ref, _ref2, _ref3);

export default __webpack_public_path__ + "static/media/NS.20bb1f3a.svg";
export { SvgComponent as ReactComponent };